import React from 'react';
import { motion } from 'framer-motion';
import { LeafIcon, ZapIcon, FlameIcon } from 'lucide-react';
const phases = [{
  icon: LeafIcon,
  number: '1',
  title: 'FASE 1 — SILENCIO',
  description: 'Ajustes nutricionales simples para bajar la inflamación y el cortisol en 7 días.'
}, {
  icon: ZapIcon,
  number: '2',
  title: 'FASE 2 — ACTIVACIÓN',
  description: 'Micro-movimientos que despiertan tu metabolismo muscular sin agotarte.'
}, {
  icon: FlameIcon,
  number: '3',
  title: 'FASE 3 — SOSTENIBILIDAD',
  description: 'Integras el protocolo en tu estilo de vida para resultados permanentes.'
}];
export function Mechanism() {
  return <section className="py-20 lg:py-32 bg-[#2D5A34]" data-id="element-126">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-128">
          <div className="inline-flex items-center gap-2 bg-[#C2856A] text-white px-4 py-2 rounded-full text-xs font-semibold mb-6 mx-auto block w-fit" data-id="element-129">
            EL MECANISMO ÚNICO
          </div>

          <h2 className="text-4xl lg:text-6xl font-bold text-white text-center mb-6" data-id="element-130">
            Presentamos el Protocolo Anti-Cortisol
          </h2>

          <p className="text-xl text-white italic text-center mb-8 max-w-3xl mx-auto" data-id="element-131">
            El sistema que da seguridad a tu cuerpo para que suelte la grasa por
            diseño
          </p>

          <p className="text-lg text-white text-center mb-12 max-w-3xl mx-auto" data-id="element-132">
            Este protocolo no se enfoca en la restricción, sino en la seguridad
            biológica. Al equilibrar tus niveles de cortisol y estrógeno
            mediante nutrición pro-metabólica y ritmos de descanso estratégicos,
            le das permiso a tu cuerpo para soltar la grasa acumulada. Cuando
            tus hormonas están en calma, tu metabolismo se activa solo.
          </p>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-133">
            {phases.map((phase, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: i * 0.1
          }} className="text-center" data-id="element-134">
                <div className="bg-[#A8D5AC] rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4" data-id="element-135">
                  <phase.icon className="w-10 h-10 text-[#2D5A34]" data-id="element-136" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-137">
                  {phase.title}
                </h3>
                <p className="text-white/90" data-id="element-138">{phase.description}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}